import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app grid-y grid-frame grid-container full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mobile_topbar = _resolveComponent("mobile-topbar")!
  const _component_topbar = _resolveComponent("topbar")!
  const _component_navbar = _resolveComponent("navbar")!
  const _component_main_content = _resolveComponent("main-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMobile())
      ? (_openBlock(), _createBlock(_component_mobile_topbar, {
          key: 0,
          class: "cell"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_topbar, { class: "cell" }),
          _createVNode(_component_navbar)
        ], 64)),
    _createVNode(_component_main_content, { class: "cell auto" })
  ]))
}